import { types, actions } from './requests'
export const CREATECORP_TYPES = {
    ...types('CREATECORP'),
}
export const CREATECORP_ACTIONS = {
    ...actions('CREATECORP'),
}
